import { createUseStore } from '../createUseStore';
import { PartnerContext } from './PartnerContext';

export const usePartnerStore = createUseStore(PartnerContext, 'PartnerContext');
